import BaseStore from '@src/utils/store/base-store';
import toWebpImage from '@src/utils/to-webp-image';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { observable } from 'mobx';
import { useEffect } from 'react';

class HighlightScreenStore extends BaseStore {
  @observable isActive = false;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable
  swiperData = [
    {
      title: '新福利',
      swiperImg: toWebpImage(require('./images/season1.png')),
      anchorNormalImg: toWebpImage(require('./images/season-code-01.png')),
      anchorHoverImg: toWebpImage(require('./images/season-code-01.png')),
      desc: '新福利',
      desc2: '特别补给+周末功勋双倍 ！战备福利全面升级！'
    },
    {
      title: '新武装',
      swiperImg: toWebpImage(require('./images/season2.png')),
      anchorNormalImg: toWebpImage(require('./images/season-code-02.png')),
      anchorHoverImg: toWebpImage(require('./images/season-code-02.png')),
      desc: '新武装',
      desc2: '全新赛季武装 已注入“虚空”能量！'
    },
    {
      title: '新时装',
      swiperImg: toWebpImage(require('./images/season3.png')),
      anchorNormalImg: toWebpImage(require('./images/season-code-03.png')),
      anchorHoverImg: toWebpImage(require('./images/season-code-03.png')),
      desc: '新时装',
      desc2: '清剿！追猎！赛季时装上新'
    },
    {
      title: '新纹样',
      swiperImg: toWebpImage(require('./images/season4.png')),
      anchorNormalImg: toWebpImage(require('./images/season-code-04.png')),
      anchorHoverImg: toWebpImage(require('./images/season-code-04.png')),
      desc: '新纹样',
      desc2: '全新动态赛季纹样「虚空」「乱流」「灯影」'
    },
    {
      title: '新背景',
      swiperImg: toWebpImage(require('./images/season5.png')),
      anchorNormalImg: toWebpImage(require('./images/season-code-05.png')),
      anchorHoverImg: toWebpImage(require('./images/season-code-05.png')),
      desc: '新背景',
      desc2: '在尘埃与能量中，与机兵并肩'
    }
  ];

  @observable swiperActionIndex = 0;

  // 轮播实际内容展示使用的store
  @observable
  seasonSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      slidesPerView: 1
    }
  });

  // 实际控制轮播拖动滚动的store
  @observable
  swiperControlStore = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      autoplay: false,
      slidesPerView: 1
    }
  });

  // 轮播切换锚点store
  @observable
  anchorSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      autoplay: false,
      slidesPerView: 'auto',
      centeredSlides: true,
      slideToClickedSlide: true,
      loopedSlides: 5
    }
  });

  use() {
    super.use();

    useEffect(
      () => {
        this.swiperActionIndex = this.seasonSwiperStore.activeIndex;
      },
      [this.seasonSwiperStore.activeIndex]
    );

    useEffect(
      () => {
        this.swiperActionIndex = this.swiperControlStore.activeIndex;
      },
      [this.swiperControlStore.activeIndex]
    );

    useEffect(
      () => {
        this.swiperActionIndex = this.anchorSwiperStore.activeIndex;
      },
      [this.anchorSwiperStore.activeIndex]
    );

    useEffect(
      () => {
        this.seasonSwiperStore.activeIndex = this.swiperActionIndex;
        this.swiperControlStore.activeIndex = this.swiperActionIndex;
        this.anchorSwiperStore.activeIndex = this.swiperActionIndex;
      },
      [this.swiperActionIndex]
    );
  }
}

export default HighlightScreenStore;
